import { SUBJECT_DETAIL_CRUMB } from "../../constants/BreadcrumConstants";
import MenuHeader from "../header/MenuHeader";

const SubjectDetailHeader = ({ header }) => {
  const path = header?.parent_subject_name
    ? [
        {
          title: `${header?.parent_subject_name}`,
          path: `/subjectlanding?subject_slug=${header?.parent_subject_slug}`,
        },
        { title: `${header?.subject_name}` },
      ]
    : [{ title: `${header?.subject_name}` }];
  return (
    <>
      <MenuHeader
        crumbs={[SUBJECT_DETAIL_CRUMB, ...path]}
        title={header?.subject_name}
        content={header?.subject_description_all}
        extStyle={{ backgroundColor: `${header?.subject_bg_color_code}` }}
        containerClass="subject_landing_bg"
        textColor="subject_land_intro_text"
        breadCrumbColor="subject_landing_padding"
        labelColor="lable_hlight_landing"
      />
    </>
  );
};

export default SubjectDetailHeader;
